<template>
  <page-template>
    <board :is-fold="isFold"
           :http-options="httpOptions"
           :config="config"
           :insert-row-function="() => insertRow('createEmptyWine')"
           :delete-row-function="(rows) => deleteRow('deleteWines', rows)"
           :disabled-play-button="true"/>
  </page-template>
</template>

<script>
import Vue from 'vue';

import config from './Config';

import WineEditor from './detail-row/WineEditor';
import CommonBoardItems from '../../CommonBoardItems';

Vue.component(config.detailRowComponentName, WineEditor);

export default {
  name: 'BoardWine',
  mixins: [CommonBoardItems],
  data() {
    return {
      config,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/board/wine/product/BoardWine.vue